import { render, staticRenderFns } from "./CreateEditContent.vue?vue&type=template&id=001bfb39&scoped=true&"
import script from "./CreateEditContent.vue?vue&type=script&lang=js&"
export * from "./CreateEditContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditContent.vue?vue&type=style&index=0&id=001bfb39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001bfb39",
  null
  
)

export default component.exports